import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { routes } from "../../../app/routes";
import { UrlService } from "../../../services";
import {
  TopbarSubmenu,
  IconDefinitions,
  TopbarMenuItem,
} from "../../../components";

export const UsersIndexTopbar = (props: any) => {
  const params = useParams();
  const returnUrl = UrlService.getQueryParams("returnUrl");
  const id = params["id"] ?? "";

  const defaultSubmenuItems: TopbarMenuItem[] = useMemo(
    (): TopbarMenuItem[] => [
      {
        label: "Users",
        icon: IconDefinitions.users,
        url: routes.user.index,
        activeMatch: routes.user.index,
        activeMatchExact: true,
        params: new Map([["id", id]]),
      },
      {
        label: "Invitations",
        icon: IconDefinitions.envelopeOpenText,
        url: routes.user.invite,
        activeMatch: [
          routes.user.invite
        ],
      }
    ],
    [id]
  );

  useEffect(() => {
    const backItem: TopbarMenuItem = {
      label: "Back",
      icon: IconDefinitions.back,
      url: returnUrl ?? "",
    };

    if (returnUrl) {
      setSubmenuItems([backItem, ...defaultSubmenuItems]);
    } else {
      setSubmenuItems(defaultSubmenuItems);
    }
  }, [defaultSubmenuItems, id, returnUrl]);

  const [submenuItems, setSubmenuItems] =
    useState<TopbarMenuItem[]>(defaultSubmenuItems);

  return <TopbarSubmenu className="p-0" items={submenuItems}></TopbarSubmenu>;
};

export default UsersIndexTopbar;

